import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const FormList = ({ ownerCustId }) => {

  const augRowsReq = useCallback((rowsReq) => {
    if (!ownerCustId) return;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('ownerCustId', ownerCustId));
  }, [ownerCustId]);

  return (
    <EntityList entity="FORM" augRowsReq={augRowsReq}/>
  )
}
